<template>
  <div class="panel">
    <div class="container">
      <div class="level">
        <div class="level-left">
          <div class="level-item logo">
            <icon type="bookmark" size="20" fill="#FFD55F"/>Theses
          </div>
          <div class="panel-nav" v-if="showNav">
            <router-link to="dashboard" class="level-item">Přehled prací</router-link>

            <router-link to="users" class="level-item">Správa uživatelů</router-link>

            <!-- <router-link to="theses" class="level-item">Správa prací</router-link> -->
          </div>
        </div>
        <div class="level-right">
          <div class="level-item username" v-if="$store.state.auth.isAuthenticated">
            <icon type="user" size="16"/>
            {{ this.$store.getters.fullUserName }}
          </div>
          <a
            class="level-item logout"
            title="Odhlásit se"
            v-if="$store.state.auth.isAuthenticated"
            @click.prevent="logOut"
          >
            <icon type="log-out" size="16"/>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['authenticated'],

  data() {
    return {};
  },

  computed: {
    showNav() {
      return this.$store.getters.userRole === 'admin';
    }
  },

  methods: {
    logOut() {
      this.$store.commit('logout');
      this.$router.push('/login');
    }
  }
};
</script>

<style lang="sass" scoped>
.panel
  background: #fff
  height: 48px
  box-shadow: 0px 2px 8px 1px rgba(black, .1)

  &-nav
    display: flex
    margin-left: 1rem

    & a
      display: block
      padding: 0 1rem
      margin: 0 !important
      line-height: 48px
      color: #4a4a4a

      &.router-link-exact-active
        font-weight: bold

      &:hover
        background: #EFF2F7
        color: black

.logo, .username, .logout
  line-height: 48px
  display: flex
  justify-content: center
  align-items: center

.logo
  font-weight: bold
  cursor: default
  user-select: none

  & i
    transition: transform .2s linear

  &:hover i
    transform: translateY(2px)

.username > *, .logo > *
  padding: 0 8px

.logout
  height: 48px
  padding: 0 16px

  &:hover
    background: #EFF2F7

.logout
  color: black
</style>


